module.exports = __webpack_public_path__ + "static/assets/915783d11712596a7291834929bb3949.png";